import {
  faBars,
  faCircleHouse,
  faQuestionCircle,
  faSearch,
} from '@fortawesome/pro-light-svg-icons';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Button, Icon } from '@nazka/nazka.mapframe.components';

import { useOnClickOutside } from '@services/hooks.service';
import { useTranslation } from '@utils/i18n/i18n.consumers';
import {
  setSearchBarExpanded,
  setTourGuideState,
  setTourStepIndex,
  setTypeOfTour,
} from '@library/GuidedTour/guided-tour.slice';

import { GUIDE_OPTIONS } from '../navbar.constants';
import { setNavbarMobileMenuOpen, toggleNavbarMobileMenu } from './navbar-mobile-menu.slice';

import './navbar-mobile-menu.styl';

function getGuideOptionByPath(pathname) {
  if (pathname.startsWith('/learn')) {
    return GUIDE_OPTIONS[0];
  }

  if (pathname.startsWith('/risks')) {
    return GUIDE_OPTIONS[1];
  }

  if (pathname.startsWith('/adaptation')) {
    return GUIDE_OPTIONS[2];
  }

  return GUIDE_OPTIONS[0];
}

function NavbarMobileMenu({ explore }) {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const isOpen = useSelector(state => state.navbarMobileMenu.isOpen);
  const isTourGuideOpen = useSelector(state => state.guidedTour.isTourGuideOpen)

  const menuRef = useRef(null);

  useOnClickOutside(menuRef, () => {
    if (isOpen && !isTourGuideOpen) {
      dispatch(setNavbarMobileMenuOpen(false));
    }
  });

  useEffect(() => {
    return () => {
      dispatch(setNavbarMobileMenuOpen(false));
    };
  }, [dispatch]);

  const handleGuidedTooltipClick = () => {
    if (location.pathname === '/explore') {
      dispatch(setNavbarMobileMenuOpen(false));
      return;
    }

    const guideOption = getGuideOptionByPath(location.pathname);

    navigate(guideOption.path);
    dispatch(setTypeOfTour(guideOption.id));
    dispatch(setTourStepIndex(0));
    dispatch(setTourGuideState(true));
    dispatch(setNavbarMobileMenuOpen(false));
  };

  return (
    <div className="navbar-mobile-menu" ref={menuRef}>
      <Button
        icon={faBars}
        className="navbar-mobile-menu__toggle"
        onClick={() => dispatch(toggleNavbarMobileMenu())}
        layout="ghost"
        hover={false}
        color="black"
      />
      {isOpen && (
        <div className="navbar-mobile-menu__panel">
          {!explore && (
            <NavLink
              to="/explore"
              className="navbar-mobile-menu__link my-sixth-learn-step"
              onClick={() => dispatch(setNavbarMobileMenuOpen(false))}
            >
              <Icon className="navbar-mobile-menu__link__icon" icon={faCircleHouse} />
              {t('Explore')}
            </NavLink>
          )}
          <Button
            className="navbar-mobile-menu__button"
            rootElProps={{ id: 'navbar-mobile-menu__search-button' }}
            layout="ghost"
            color="black"
            icon={faSearch}
            onClick={() => {
              dispatch(setSearchBarExpanded(true));
              dispatch(setNavbarMobileMenuOpen(false));
            }}
            hover={false}
          >
            {t('Search')}
          </Button>
          <Button
            layout="ghost"
            icon={faQuestionCircle}
            className="navbar-mobile-menu__button"
            color="black"
            hover={false}
            onClick={handleGuidedTooltipClick}
          >
            <div className="navbar-mobile-menu__button__help">
              {t('Help')}
            </div>
          </Button>
          {explore && (
            <div className="navbar-mobile-menu__guide-options">
              {GUIDE_OPTIONS.map(option => (
                <button
                  key={option.id}
                  type="button"
                  className="navbar-mobile-menu__guide-option"
                  onClick={() => {
                    navigate(option.path);
                    dispatch(setTypeOfTour(option.id));
                    dispatch(setTourStepIndex(0));
                    dispatch(setTourGuideState(true));
                    dispatch(setNavbarMobileMenuOpen(false));
                  }}
                >
                  {t(option.label)}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default NavbarMobileMenu;
